"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendDnBScripts = void 0;
var appendDnBScripts = exports.appendDnBScripts = function appendDnBScripts() {
  var vidScript = document.createElement('script');
  var coreTagScript = document.createElement('script');
  vidScript.type = 'text/javascript';
  vidScript.src = '//vid1029.d41.co/sync/';
  coreTagScript.type = 'text/javascript';
  coreTagScript.src = '//cdn-0.d41.co/tags/dnb_coretag_v4.min.js';
  coreTagScript.async = 'true';
  coreTagScript.onload = function () {
    // eslint-disable-next-line no-undef, camelcase
    dnbvid.getData('vid1029', 'json', 'T', function (dnb_Data) {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('gcs_dnb_Data', JSON.stringify(dnb_Data));
      }
    });
    document.body.appendChild(vidScript);
  };
  window.addEventListener('load', function () {
    document.body.appendChild(coreTagScript);
  });
};